var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitoring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2003_2005",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2003_2005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.08349 35C4.25099 35 3.52887 34.6915 2.91714 34.0746C2.30571 33.4574 2 32.7287 2 31.8887V21.6221H12.1287L15.4125 28.2487C15.546 28.5185 15.7387 28.726 15.9906 28.8713C16.2425 29.0162 16.5072 29.0887 16.7847 29.0887C17.0622 29.0887 17.3294 29.0214 17.5863 28.8867C17.8431 28.752 18.0384 28.5497 18.1722 28.28L24.1075 17.8113L25.5565 20.7821C25.6903 21.0621 25.8857 21.2721 26.1425 21.4121C26.3993 21.5521 26.6665 21.6221 26.944 21.6221H39V31.8887C39 32.7287 38.6943 33.4574 38.0829 34.0746C37.4711 34.6915 36.749 35 35.9165 35H5.08349ZM16.9078 24.2821L14.4875 19.3513C14.354 19.0815 14.1587 18.874 13.9015 18.7287C13.6447 18.5838 13.3775 18.5113 13.1 18.5113H2V10.1113C2 9.27127 2.30571 8.54265 2.91714 7.9254C3.52887 7.30847 4.25099 7 5.08349 7H35.9165C36.749 7 37.4711 7.30847 38.0829 7.9254C38.6943 8.54265 39 9.27127 39 10.1113V18.5113H27.9153L25.5875 13.7821C25.454 13.5021 25.2587 13.2974 25.0015 13.1679C24.7447 13.0382 24.4775 12.9733 24.2 12.9733C23.9225 12.9733 23.6604 13.0382 23.4138 13.1679C23.1671 13.2974 22.977 13.4918 22.8435 13.7513L16.9078 24.2821Z",
    fill: "#819DF9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoring);
export default __webpack_public_path__ + "static/media/monitoring.53b65c394dc08925a6a98d1b11e28899.svg";
export { ForwardRef as ReactComponent };